var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value.value)?_c('span',[_c('span',[_vm._v(_vm._s(_vm.value.selectedOperator)+":")]),_c('span',[_vm._v(_vm._s(("" + (_vm.value.value)).replaceAll(',', ', ')))])]):_c('span',[_vm._v(" "+_vm._s(_vm.$t('N/A'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }